(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["matte-product-share"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',async function(event){
  const button=event.target.closest('[data-share-instagram],[data-share-copy]');
  if(!button)return;
  const root=button.closest('[data-product-share]');
  if(!root)return;
  const status=root.querySelector('[role="status"]');
  const instagram=button.hasAttribute('data-share-instagram');
  if(instagram&&navigator.share){
    try{await navigator.share({title:root.dataset.title,url:root.dataset.url});return;}
    catch(error){if(error.name==='AbortError')return;}
  }
  try{
    await navigator.clipboard.writeText(root.dataset.url);
    status.textContent=instagram?root.dataset.instagram:root.dataset.copied;
  }catch(error){
    const input=root.querySelector('input');
    input.hidden=false;
    input.focus();
    input.select();
    status.textContent=root.dataset.manual;
  }
});

  } catch(e) { console.error(e); }
})();
})();
